import React, { createContext, useContext, useEffect, useState } from "react";
import { notify } from "react-notify-toast";

import { spinnerService } from "@chevtek/react-spinners";
import { useGetOrders } from "../../hooks/api/wc/useGetOrders";
import useGetProfileInfo from "../../hooks/api/useGetProfileInfo";
import { useQuery } from "../../hooks";
import { useAuthContext } from "../../context/auth";
import useQueryParams from "../../hooks/useQueryParams";

const statesData = [
  {
    value: "ACT",
    label: "ACT",
  },
  {
    value: "NSW",
    label: "NSW",
  },
  {
    value: "NT",
    label: "NT",
  },
  {
    value: "QLD",
    label: "QLD",
  },
  {
    value: "SA",
    label: "SA",
  },
  {
    value: "TAS",
    label: "TAS",
  },
  {
    value: "VIC",
    label: "VIC",
  },
  {
    value: "WA",
    label: "WA",
  },
];

// Create a new context
export const OrdersContext = createContext();

export const useOrdersContext = () => useContext(OrdersContext);

// Create a provider component
export const OrdersProvider = ({ children }) => {
  const query = useQuery();
  const { setParamsOnly } = useQueryParams();

  const { ready, isManager, isProductionStaff } = useAuthContext();
  const profileInfoHook = useGetProfileInfo();
  const [additionalParams, setAdditionalParams] = useState([""]);
  const ordersHook = useGetOrders(additionalParams);

  const myStatesOnly = !!query.get("my-states-only");
  const orders = ordersHook.isLoading ? [] : ordersHook.data.list;
  const states = [
    {
      value: "",
      label: myStatesOnly ? "My States" : "All States",
    },
    ...statesData,
  ];

  // Show spinner and handle notifications
  useEffect(() => {
    if (ordersHook.isLoading) {
      spinnerService.show("ug");
    } else {
      spinnerService.hide("ug");

      // New admin orders redirected here
      if (query.has("created")) {
        notify.show(`Order number #${query.get("created")} successfully created`, "success", 3000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordersHook.isLoading]);

  // Set My State Data
  useEffect(() => {
    // TODO : set my states based on profile info
    if (myStatesOnly) {
      setAdditionalParams({ state: "NSW,VIC" });
    } else {
      setAdditionalParams({});
    }
  }, [profileInfoHook.isLoading, myStatesOnly]);

  /* Handle Auto load my sates => On Page Load 
     Only for staff roles
     Not for admins
  */
  useEffect(() => {
    if (isManager() || isProductionStaff()) {
      setParamsOnly({ "my-states-only": true, page: 1 });
    }
  }, [ready]);

  return (
    <OrdersContext.Provider
      value={{
        orders,
        isLoadingOrders: ordersHook.isLoading,
        totalPages: ordersHook.data?.totalPages,
        myStatesOnly,
        states,
      }}
    >
      {children}
    </OrdersContext.Provider>
  );
};

export default OrdersContext;
